import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { isFunction } from 'lodash-es';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { AlertDialogData } from '@@core/models/alert-dialog.model';
import {
	AlertDialogComponent,
	ConfirmationDialogComponent,
	ConfirmationDialogData
} from '@@shared/dialog';

@Injectable({
	providedIn: 'root'
})
export class ConfirmationDialogService {
	// Services declaration
	readonly #dialog = inject(MatDialog);
	readonly #dialogService = inject(DialogService);

	openDialog(
		dialogConfig: DynamicDialogConfig<ConfirmationDialogData>,
		close?: (confirmed: boolean) => void
	): DynamicDialogRef<ConfirmationDialogComponent> {
		const dialogRef = this.#dialogService.open(ConfirmationDialogComponent, {
			...dialogConfig,
			header: dialogConfig.data?.title
		});

		if (isFunction(close)) {
			dialogRef.onClose.subscribe((confirmed: boolean) => {
				close(confirmed);
			});
		}

		return dialogRef;
	}

	showAlert(config: AlertDialogData): MatDialogRef<AlertDialogComponent, void> {
		return this.#dialog.open<AlertDialogComponent, AlertDialogData, void>(
			AlertDialogComponent,
			{
				data: {
					...config
				}
			}
		);
	}
}
